<div class="upload-container">
  <input multiple
         type="file"
         (change)="onFileSelected($event)">
  <ul>
    <li *ngFor="let file of uploadedFiles">
      {{file.name}}
    </li>
  </ul>
</div>
